import { render, staticRenderFns } from "./vListIngredientCost.vue?vue&type=template&id=243ad501&scoped=true"
import script from "./vListIngredientCost.vue?vue&type=script&setup=true&lang=ts"
export * from "./vListIngredientCost.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vListIngredientCost.vue?vue&type=style&index=0&id=243ad501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243ad501",
  null
  
)

export default component.exports